// const BaseUrl = "http://localhost:8080";
const BaseUrl = "https://admitcard.hkcl.net";

export default BaseUrl;